import React, { FC } from 'react'

import { FieldErrors, UseFormRegister } from 'react-hook-form'

import { ErrorTxt } from 'src/components/atoms'
import { TextInput } from 'src/components/atoms/inputs/TextInput'
import { FormItemVertical } from 'src/components/molecules/formSets/FormItemVertical'

import { UpsertProjectFormEntity } from 'src/types'

type Props = {
  register: UseFormRegister<UpsertProjectFormEntity>
  formErrors: FieldErrors<UpsertProjectFormEntity>
  className?: string
}

export const ProjectBuildingInputArea: FC<Props> = ({ register, formErrors, className }) => {
  return (
    <div className={className}>
      <div className="tw-grid tw-gap-s2">
        <div className="tw-flex tw-items-center">
          <FormItemVertical title="総戸数">
            <TextInput
              placeholder="10"
              className="tw-w-[6rem]"
              type="number"
              {...register('roomCount')}
            />
          </FormItemVertical>
          {formErrors.roomCount && (
            <ErrorTxt text={formErrors.roomCount.message ?? ''} showIcon className="tw-ml-s1" />
          )}
        </div>
      </div>
    </div>
  )
}
